<template>
  <el-table-column
    prop="felir"
    sortable="custom"
    label="FELIR"
    show-overflow-tooltip
    min-width="100"
  >
    <template slot-scope="scope">
      {{ scope.row.company.felir }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'felir',
};
</script>
